'use client';

import { Popover, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import React, { Fragment, useMemo } from 'react';

import { FilterActions, useFilterBreedData, useFilterContext } from '@/entities/filters';

import FilterButton from './FilterButton';
import FilterPopover from './FilterPopover';

const FilterComponent: React.FC = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { animalType, pubType, openPopoverHandle } = useFilterContext();
  const { breedData, isLoading } = useFilterBreedData(animalType, pubType);

  const currentParams = useMemo(
    () => new URLSearchParams(Array.from(searchParams.entries())),
    [searchParams]
  );

  const dropFiltersHandle = () => {
    sessionStorage.setItem('animal-type', 'all');
    sessionStorage.setItem('publication-type', 'all');
    sessionStorage.removeItem('breeds');
    currentParams.delete('breeds');

    currentParams.set('animal-type', 'all');
    currentParams.set('publication-type', 'all');
    approveFilterHandle();
    close();
  };

  const approveFilterHandle = () => {
    const search = currentParams.toString();
    const query = search ? `?${decodeURI(search)}` : '';
    router.push(`${pathname}${query}`);
  };

  return (
    <section className="relative flex items-center pl-4 text-left">
      <Popover as={Fragment}>
        {({ open, close }) => (
          <>
            <FilterButton />
            <Transition
              appear
              as={Fragment}
              show={open}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <section className="fixed left-0 top-20 z-[60] mt-2 h-full w-screen origin-top-right rounded-md bg-white/60 px-4 py-2 shadow-lg ring-1 ring-black ring-opacity-5 backdrop-blur focus:outline-none dark:bg-slate-600/70 md:absolute md:-left-4 md:top-10 md:h-auto md:w-auto md:min-w-[400px]">
                <div className="inline-flex w-full pb-6 md:pb-0">
                  <p className="text-2xl md:hidden">Фильтр</p>
                  <button className="ml-auto mr-0 flex md:mt-2" onClick={close}>
                    <XMarkIcon className="h-8 w-8" />
                  </button>
                </div>
                <div>
                  <FilterPopover
                    currentParams={currentParams}
                    breedData={breedData}
                    isLoading={isLoading}
                    setIsOpen={openPopoverHandle}
                  />
                  <FilterActions
                    onApply={approveFilterHandle}
                    onReset={dropFiltersHandle}
                    close={close}
                  />
                </div>
              </section>
            </Transition>
          </>
        )}
      </Popover>
    </section>
  );
};

export default FilterComponent;
